import { withInstall } from '@zoryn/utils'
import TaskCenter from './src/task-center.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTaskCenter: SFCWithInstall<typeof TaskCenter> =
  withInstall(TaskCenter)
export default ZTaskCenter

export * from './src/task-center'
export * from './src/types'
export * from './src/constants'
export * from './src/utils/task-api'
export * from './src/utils/task-mapper'
export * from './src/utils/task-mock'
export { useTaskList } from './src/composables/use-task-list'
export type { TaskCenterInstance } from './src/instance'
